"use strict";

var fav;
/////////////////////
//////////////////////////////////////////
////////////////////////
///////////////////////////////////////////
////////////////////////
fav = require('@/assets/alli/favicon.ico');
///////////////////////
//////////////////////////////////////////
//////////

let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
link.type = 'image/x-icon';
link.rel = 'shortcut icon';
link.href = fav;
document.getElementsByTagName('head')[0].appendChild(link);

import Vue from 'vue';
import App from './App';
import router from './router';

import { MdButton, MdIcon, MdCard, MdList, MdApp, MdToolbar, MdDrawer, MdContent, MdSubheader, MdTable, MdEmptyState, MdRipple, MdField, MdProgress, MdMenu, MdSnackbar, MdDialog, MdDialogAlert } from 'vue-material/dist/components';

import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';

import './styles/main.scss';

Vue.use(MdButton);
Vue.use(MdIcon);
Vue.use(MdCard);
Vue.use(MdList);
Vue.use(MdApp);
Vue.use(MdToolbar);
Vue.use(MdDrawer);
Vue.use(MdContent);
Vue.use(MdSubheader);
Vue.use(MdTable);
Vue.use(MdEmptyState);
Vue.use(MdRipple);
Vue.use(MdField);
Vue.use(MdProgress);
Vue.use(MdMenu);
Vue.use(MdSnackbar);
Vue.use(MdDialog);
Vue.use(MdDialogAlert);

////////////////////////////////////////////////////////////////////////
/////////////////////////////
////////////////////////////////////////////////////
/////////
global.apiUrl = '/api'; // PROD
//////////

import { Auth } from '@wsb/wsb-jsbase';
global.Auth = new Auth(global.apiUrl);

/////////////////////
/////////////////////////////////////////
//////////////////////////////////////////////////
////////////////////////
///////////////////////////////////////////
////////////////////////////////////////////
////////////////////////
Vue.prototype.$portalName = 'Mijn Alliance';
Vue.prototype.$infoMail = 'mailingen@alliancegroep.com';
///////////////////////
///////////////////////////////////////
//////////////////////////////////////////
//////////

global.cache = {};

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js